import { AdminEventsTable } from '../AdminEventsTable';

/**
 * Dedicated full-page view of the System Events audit log (super-admin only).
 * Reuses {@link AdminEventsTable}, which provides timeframe + column filters
 * (event type, category, customer, description), sortable columns, pagination
 * and CSV export — with more room than the dashboard card.
 */
export function SystemEventLogPage() {
  return (
    <div className="flex flex-col gap-4 h-[calc(100vh-9rem)]">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">System Event Log</h1>
        <p className="text-sm text-gray-500">
          Vollständiger Audit-Verlauf aller System-Events — filterbar nach Zeitraum,
          Event-Typ, Kategorie, Kunde und Beschreibung.
        </p>
      </div>
      <div className="flex-1 min-h-0">
        <AdminEventsTable />
      </div>
    </div>
  );
}
